var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"studentRegister page-padding"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('route.studentRegister')))]),_c('div',{staticClass:"register-main"},[_c('StudentFormInformation',{attrs:{"system":"gear"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }